import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import isMobilePhone from "validator/lib/isMobilePhone";
import Otp from "./otp";
import SideSection from "../../components/sideContent/sideSection";
import renderHTML from "react-render-html";
import withStyles from "@material-ui/core/styles/withStyles";
import TermsAndCondition from "../../components/common/termsAndCondition";
import { useHistory } from "react-router-dom";
import {
  Box,
  Button,
  Checkbox,
  Typography,
  TextField,
  InputAdornment,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormControlLabel,
} from "@material-ui/core";
import { useStyles } from "./indexStyles";
import { Images } from "../../constants/images";
import {
  buildLoginPayload,
  buildResendOtpPayload,
  buildSubmitOtpPayload,
  isLoginNextButton,
} from "../../helpers/proposal";
import { postWebService } from "../../helpers/server";
import {
  getApplicationRoute,
  parseMessage,
  setStorageItem,
} from "../../helpers/utils";
import { validations } from "../../messages/validation";
import { Utils } from "../../constants/utils";
import { SOME_THING_WENT_WRONG_TEXT } from "../../constants";
import { buildSystemErrorMessage } from "../../helpers/proposal";
import { getWebService } from "../../helpers/server";

const Login = (props) => {
  const history = useHistory();

  const [errorMessage, setErrorMessage] = useState({ mobile: "" });
  const [errors, setErrors] = useState([]);
  const [form, setForm] = useState({
    mobile: "",
    opt: "",
    hasError: false,
  });
  const [term, setTerm] = useState({
    terms: false,
  });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isProceeded, setIsProceeded] = useState(false);
  const [onfocusMobile, setOnfocusMobile] = useState(false);
  const [step, setStep] = useState("login");
  const [touchFields, setTouchFields] = useState({ mobile: false });
  const [modal, setModal] = useState({
    open: false,
    staticPage: false,
  });
  const [content, setContent] = useState({ body: null });

  const {
    classes: {
      subTitle,
      imgLg,
      formInput,
      formInputCard,
      input,
      numberInputBox,
      mobileLabel,
      mobileLabel1,
      mobileInput,
      mobileInputFocus,
      errorMsg,
      customBtn,
      button,
      mobileLabelOtp,
      logoVShield,
    },
    classes,
  } = props;

  useEffect(() => {
    if (localStorage.getItem("token")) {
      navigateTo(getApplicationRoute("dashboard"));
    }
  });

  useEffect(() => validateMobile(), [form.mobile]);

  const validateMobile = () => {
    if (form.mobile) {
      let isValid = isMobilePhone(form.mobile, ["en-IN"]);
      setStateVariables(
        "mobile",
        isValid,
        isValid ? "" : validations.mobile.valid
      );
    } else if (touchFields.mobile) {
      setErrorMessageState("mobile", validations.mobile.required);
    }
  };

  const validateInputLength = (event) => {
    let elName = event.target.name;
    let elValue = event.target.value;

    if (event.target.name === "mobile") {
      var clean = elValue.replace(/[^0-9]+/g, "");
      event.target.value = clean;
    }

    if (elValue.length > Utils.limit.digits[elName]) {
      event.target.value = elValue.substring(0, Utils.limit.digits[elName]);
    }
  };

  const toggleClass = () => setOnfocusMobile(true);

  const setStateVariables = (key, isValid, message) => {
    setFormState("hasError", !isValid);
    setErrorMessageState(key, message);
    setTouchFieldsState(key, true);
  };

  const setFormState = (name, value) => setForm({ ...form, [name]: value });

  const setErrorMessageState = (name, value) =>
    setErrorMessage({ ...errorMessage, [name]: value });

  const setTouchFieldsState = (name, value) =>
    setTouchFields({ ...touchFields, [name]: value });

  const handleChange = (event) => {
    setErrors([]);
    setFormState(event.target.name, event.target.value);
  };

  const goToPrevStep = () => window.location.reload();

  const navigateTo = (pathname) => history.push({ pathname });

  /* Start: User Content: generate & verify OTP */
  const cbError = ({ data: { error_msg }, data }) => {
    setIsFormSubmitted(false);
    setIsProceeded(false);

    const message = parseMessage(error_msg);
    if (Array.isArray(message)) {
      setErrors(message);
    } else {
      let messageArray = [];
      messageArray.push(message);
      setErrors(messageArray);
    }
  };

  const sendOTP = async (payload) => {
    try {
      setIsFormSubmitted(true);
      setErrors([]);
      await postWebService("user/login", payload);

      setIsFormSubmitted(false);
      setStep("otp");
    } catch (error) {
      const systemError = {
        data: {
          error_msg: SOME_THING_WENT_WRONG_TEXT,
        },
      };
      cbError(
        error && error.response && error.response.data
          ? error.response.data
          : systemError
      );
    }
  };

  function onTermsCondition(e) {
    setTerm({
      ...term,
      terms: !term.terms,
    });
  }

  const toggleModal = (key = "open", value = true) => {
    setModal({
      ...modal,
      [key]: value,
    });
  };

  // const handleStaticPageClick = async (keyname = "", title = "") => {
  //   try {
  //     const response = await getWebService(keyname);
  //     const {
  //       data: { content: body },
  //     } = response.data;

  //     setContent({
  //       ...content,
  //       title,
  //       body,
  //     });
  //     toggleModal("staticPage", true);
  //   } catch (error) {
  //     cbError(
  //       error && error.response && error.response.data
  //         ? error.response.data
  //         : buildSystemErrorMessage()
  //     );
  //   }
  // };
  const handleStaticPageClick = (url, title) => {
    window.open(url, "_blank");
    setTerm({
        ...term,
        terms: true
    });

  };

  const submitLogin = (event) => {
    event.preventDefault();

    sendOTP(buildLoginPayload(form));
  };

  const resendOtp = () => sendOTP(buildResendOtpPayload(form));

  /* const cbSuccessSubmitOtp = ({ token }) => {
    setErrors([]);
    setIsProceeded(false);
    setStorageItem("token", token);
    setStorageItem("mobile", form.mobile);
    navigateTo(getApplicationRoute("dashboard"));
  }; */

  const cbSuccessSubmitOtp = ({
    token,
    name = "",
    dealer_id = "",
    dealership_name = "",
    email = "",
    mobile = "",
    skip_copayment = false,
    master_otp_login = false,
    otp_details,
  } = {}) => {
    setErrors([]);
    setIsProceeded(false);
    setStorageItem("token", token);
    setStorageItem(
      "user_details",
      JSON.stringify({ name, dealer_id, dealership_name, email, mobile })
    );
    // setStorageItem("skip_copayment", skip_copayment);
    setStorageItem("master_otp_login", master_otp_login);
    setStorageItem("master_otp_user", otp_details.master_otp_user);
    setStorageItem("state_code", otp_details.state_code);
  };

  const submitOtp = async (event) => {
    event.preventDefault();
    setIsProceeded(true);
    setErrors([]);
    try {
      const response = await postWebService(
        `user/verify`,
        buildSubmitOtpPayload(form)
      );

      cbSuccessSubmitOtp(response.data.data);
    } catch (error) {
      const systemError = {
        data: {
          error_msg:
            "It looks like something went wrong. Please try again in a while.",
        },
      };
      cbError(
        error && error.response && error.response.data
          ? error.response.data
          : systemError
      );
    }
  };
  
  return (
    <>
      <Box id="mainBlock">
        <SideSection
          onFocus={onfocusMobile}
          title={"Safety Verification"}
          description={
            <Typography variant={"body1"} className={subTitle}>
              For safety concerns, we need to validate your mobile number. We'll
              send you a <b>One Time Password</b> on this number.
            </Typography>
          }
          image={<img src={Images.familyIllus} className={imgLg} alt="" />}
          data={
            <Box className={formInput}>
              <Box className={classes.logoHeader}>
                <Box>
                  <img
                    src={Images.vShield}
                    alt="Vivo Shield"
                    className={logoVShield}
                  />
                  <Typography variant={"h3"} className={classes.textHeader}>
                    My Account
                  </Typography>
                </Box>
                {step === "otp" && (
                  <Box className={classes.otpHeader}>
                    <Typography variant="body2">
                      OTP was sent to{" "}
                      <span className={classes.bold}>+91 {form.mobile}</span>
                      <span
                        className={classes.btnChange}
                        onClick={goToPrevStep}
                      >
                        Change
                      </span>
                    </Typography>
                  </Box>
                )}
              </Box>
              <Box className={formInputCard}>
                {step === "login" && (
                  <form
                    noValidate
                    autoComplete="off"
                    className={input}
                    onSubmit={submitLogin}
                  >
                    <Box className={numberInputBox}>
                      <Typography className={mobileLabel}>
                      You can view your plan details, download plan documents and initiate claims here.
                      </Typography>
                      <Typography className={mobileLabel1}>
                      Please login with your registered mobile number to continue.
                      </Typography>
                      <TextField
                        id="standard-basic"
                        label={"Your Registered Mobile Number"}
                        variant="standard"
                        value={form.mobile}
                        className={
                          !onfocusMobile ? mobileInput : mobileInputFocus
                        }
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              +91
                            </InputAdornment>
                          ),
                        }}
                        name="mobile"
                        onInput={validateInputLength}
                        onChange={handleChange}
                        onFocus={toggleClass}
                        autoComplete="off"
                      />
                      {errorMessage.mobile !== "" && (
                        <Box className={"mt-5"}>
                          <Typography
                            variant={"body2"}
                            color={"primary"}
                            className={errorMsg}
                          >
                            {errorMessage.mobile}
                          </Typography>
                        </Box>
                      )}
                    </Box>

                    {errors.length > 0 && (
                      <Box className={`mt-5`}>
                        {errors.map((item, index) => {
                          return (
                            <Typography
                              key={index}
                              className={`mb-5 ${errorMsg}`}
                              color={"primary"}
                              variant={"body2"}
                            >
                              {item}
                            </Typography>
                          );
                        })}
                      </Box>
                    )}

                    <Box style={{ display: "inline-flex" }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                          checked={term.terms}
                            onChange={onTermsCondition}
                            name="termsAccepted"
                            color="secondary"
                          />
                        }
                        label="I accept the"
                      />
                      <Box
                        style={{
                          marginLeft: "-10px",
                          marginTop: "10px",
                          color: "#3c63fc",
                          cursor: "pointer",
                        }}
                      >
                        <Typography
                          variant="body1"
                        
                          onClick={() =>
                            handleStaticPageClick(
                              "https://garantie.in/terms-conditions/",
                              "Terms & Conditions"
                            )
                          }
                        >
                          Terms &amp; Conditions
                        </Typography>
                      </Box>
                    </Box>

                    {/* <label
                      className="TouCheckboxLabel"
                      style={{ display: "flex", alignItems: "baseline" }}
                    >
                      <input
                        className="TouCheckbox"
                        value={form.terms}
                        type="checkbox"
                        name="termsAccepted"
                        onChange={onTermsCondition}
                      />

                      <div style={{ display: "flex", alignItems: "baseline" }}>
                        <div>I accept the&nbsp;</div>
                        <span
                          style={{
                            color: "blue",
                          }}
                          onClick={() =>
                            handleStaticPageClick(
                              "term-and-conditions",
                              "Terms & Conditions"
                            )
                          }
                        >
                          Terms &amp; Conditions
                        </span>
                      </div>
                    </label> */}

                    <Box className={customBtn}>
                      <Button
                        type="submit"
                        size="large"
                        variant={"contained"}
                        color="primary"
                        className={button}
                        {...((isFormSubmitted ||
                          isLoginNextButton(
                            form,
                            errorMessage,
                            !term.terms
                          )) && {
                          disabled: true,
                        })}
                      >
                        {!isFormSubmitted ? (
                          renderHTML("Next")
                        ) : (
                          <CircularProgress
                            color={"inherit"}
                            className={classes.loaderStyle}
                            size={20}
                          />
                        )}
                      </Button>
                    </Box>
                  </form>
                )}

                {step === "otp" && (
                  <form
                    noValidate
                    autoComplete="off"
                    className={input}
                    onSubmit={submitOtp}
                  >
                    <Box className={numberInputBox}>
                      <Typography variant={"body1"} className={mobileLabelOtp}>
                        Enter OTP
                      </Typography>
                      <Box>
                        <Otp
                          changeNumber={true}
                          onChangeNumberClick={goToPrevStep}
                          otpCallBack={(otp) => setFormState("otp", otp)}
                          resendOtp={resendOtp}
                        />
                      </Box>
                    </Box>

                    {errors.length > 0 &&
                      errors.map((item, index) => {
                        return (
                          <Typography
                            key={index}
                            className="mb-5"
                            color={"primary"}
                            variant={"body2"}
                          >
                            {item}
                          </Typography>
                        );
                      })}

                    <Box className={customBtn}>
                      <Button
                        type="submit"
                        size="large"
                        variant={"contained"}
                        color="primary"
                        disabled={form.otp && form.otp.length !== 6}
                        className={button}
                      >
                        {!isProceeded ? (
                          renderHTML("PROCEED")
                        ) : (
                          <CircularProgress
                            color={"inherit"}
                            className={classes.loaderStyle}
                            size={20}
                          />
                        )}
                      </Button>
                    </Box>
                  </form>
                )}
              </Box>
            </Box>
          }
        />
      </Box>

      <TermsAndCondition
        state={modal.staticPage}
        onclick={() => toggleModal("staticPage", false)}
        body={content?.body}
      />
    </>
  );
};

export default withStyles(useStyles, { withTheme: true })(Login);
